import { registerQuery, useQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export const SEARCH_USER_IN_HUB = registerQuery({
  fieldName: 'search_user_in_hub',
  args: ['userId'],
  fetcher: ({
    userId
  }) => {
    return http.put('users-search/v1/users-search/app/search', {
      data: {
        hubId: PortalIdParser.getPortalIdFromPath(),
        mustMatchUserIds: [userId],
        offset: 0,
        limit: 1,
        onlyConfirmedUsers: false,
        onlyVisibleUsers: false,
        onlyHubspotters: false,
        uniqueUserIds: false,
        includePartnerUsers: true,
        includeDeactivatedUsers: false
      }
    });
  }
});
export const useIsUserInOwnHub = userId => {
  var _data$search_user_in_;
  const {
    data,
    loading,
    error
  } = useQuery(SEARCH_USER_IN_HUB, {
    variables: {
      userId
    },
    skip: !PortalIdParser.getPortalIdFromPath()
  });
  const isUserInOwnHub = Boolean(data === null || data === void 0 || (_data$search_user_in_ = data.search_user_in_hub) === null || _data$search_user_in_ === void 0 || (_data$search_user_in_ = _data$search_user_in_.results) === null || _data$search_user_in_ === void 0 ? void 0 : _data$search_user_in_.length);
  return {
    isUserInOwnHub,
    isUserInOwnHubLoading: loading,
    isUserInOwnHubError: error
  };
};